<template>
  <section>
    <HTabs v-model:activeTab="tab" class="channel-tabs">
      <template #tabs>
        <HTab name="channels">
          <PDrawerTabLabel
            title="Canais"
            icon="icHashtag"
            :counters="loggedStaffCounters.channels"
          />
        </HTab>
        <HTab name="followUp">
          <PDrawerTabLabel
            title="Follow Up"
            icon="icAlertRotatinLight"
            :counters="loggedStaffCounters.fupChannels"
          />
        </HTab>
        <HTab name="mentions">
          <PDrawerTabLabel
            title="Pra você"
            icon="icMention"
            :counters="loggedStaffCounters.mentions"
          />
        </HTab>
        <HTab name="archivedAt">
          <PDrawerTabLabel title="Encerrados" icon="icChatRead" />
        </HTab>
      </template>
      <template #contents>
        <HTabContent name="channels"> <PChannelTab /></HTabContent>
        <HTabContent name="followUp"> <PFollowUpTab /></HTabContent>
        <HTabContent name="mentions"> <PMentionTab /></HTabContent>
        <HTabContent name="archivedAt"> <PArchivedTab /></HTabContent>
      </template>
      <template #right-header> <PDrawerToggle /> </template>
    </HTabs>

    <PSidenavFilters title="Canais" :kind="kind" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import { HTab, HTabContent, HTabs } from '@/components/shared/atoms'
import { CHANNEL_KINDS } from '@/models/channels'

import PDrawerTabLabel from '../../atoms/drawer/PDrawerTabLabel.vue'
import PDrawerToggle from '../../atoms/drawer/PDrawerToggle.vue'
import PSidenavFilters from '../sidenav/PSidenavFilters.vue'
import PArchivedTab from './channel/PArchivedTab.vue'
import PChannelTab from './channel/PChannelTab.vue'
import PFollowUpTab from './channel/PFollowUpTab.vue'
import PMentionTab from './channel/PMentionTab.vue'

export default {
  components: {
    PDrawerTabLabel,
    PChannelTab,
    PFollowUpTab,
    PMentionTab,
    PArchivedTab,
    PDrawerToggle,
    PSidenavFilters,
    HTabs,
    HTab,
    HTabContent
  },
  data() {
    return {
      kind: CHANNEL_KINDS.CHANNEL,
      tab: 'channels'
    }
  },
  computed: {
    ...mapGetters('channel/staff', ['loggedStaffCounters'])
  }
}
</script>
<style lang="scss" scoped>
.channel-tabs {
  :deep(.h-tabs__header) {
    padding-top: var(--gl-spacing-01);
    background-color: var(--sys-color-surface-background-default);
    position: sticky;
    top: 0;
    z-index: 1;
    margin-bottom: 0;
  }
}
</style>
